<template>
  <div class="bigbox cursorstyle">
    <div class="nav">
      当前位置：<span @click="userObj.routeClick('3')" class="navBoxTxt"> 首页 </span> >
      <span @click="userObj.routeClick('2')" class="navBoxTxt">成果转化</span> >
      通知公告列表

    </div>
    <div class="bigitembox">
      <div class="itemtop">
        <div class="left">
          <img src="@/assets/chengguo/编组 15.png">
          商家名录
        </div>
      </div>
      <div class="" style="width: 100%;">
        <template>
          <el-table :data="tableData" style="width: 100%;height: 100%;" @row-click="openDetails">
            <el-table-column type="index" label="序号" show-overflow-tooltip width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="name" label="标题" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="发布时间" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="view_count" label="浏览次数" show-overflow-tooltip
                             align="center">
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
    <div class="" style="margin-top: 1vh; display: flex; justify-content: right;  margin-bottom: 2vh;">
      <div class="fenye">
        <!-- 分页 -->
        <el-pagination background :page-size="15" layout=" prev, pager, next" :total="this.total_count"
                       :current-page="SubmitObj.page_num" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  // 商家名录
  informationList
} from '@/api/Achievements.js'

export default {
  data() {
    return {
      // 通知公告列表
      tableData: [],
      // 总页数
      total_count:50,
      SubmitObj: {
        page_num: null,
        page_size:15
      }

    }
  },
  mounted() {
    this.informationLists(1)

  },
  methods: {
    openDetails(row) {
      this.$router.push({
        path: './informationDetail',
        query: {
          type: row.ip_type,
          ids: row.id
        }
      })
    },
    // 列表跳转
    handleCurrentChange(val) {
      this.SubmitObj.page_num = val
      this.informationLists(1)
    },
    // 商家名录
    async informationLists(val) {
      let obj
      //
      if (val == 1) {
        obj = this.SubmitObj
        obj.show_position = 2
      } else {
        obj = {show_position:2}
      }
      let res = await informationList(obj)
      if (res.code == '00000') {
        this.tableData = res.data.result
        this.total_count = res.data.total_count
      }
    },
  }
}
</script>

<style scoped="scoped" lang="less">
.bigbox {
  width: 63vw;
  margin: 0 auto;
  // border: 1px red solid;
}

.nav {
  margin-top: 14px;
  font-size: 1rem;
  color: #333333;
}


.bigitembox {
  width: 100%;
  height: calc(62.5vh + 29.5px);
  margin-right: 24px;
  margin-top: 1.8vh;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 3px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  overflow: hidden;
}

.itemtop {
  height: 3.6vh;
  width: 100%;
  // border: 1px red solid;
  display: flex;
  justify-content: space-between;
  line-height: 3.6vh;
  // text-align: center;

}

.itemtop .left {
  width: 7.6vw;
  background: url('~@/assets/chengguo/编组 12.png') no-repeat center;
  background-size: 100% 100%;
  color: #333333;
  font-size: 1rem;

  img {
    height: 54%;
    vertical-align: middle;
    margin-left: 3%;
    margin-right: 10%;
  }
}

.itemtop .right {
  margin-right: 3%;
  color: #333333;
  font-size: 0.87rem;
}

/deep/ .el-table__header th {
  padding: 0;
  line-height: 3.6vh;
  height: 3.6vh;
  background: #F6FFF6;
  font-weight: bold;
  color: #666666;
  font-size: 0.88rem;

}

/deep/ .el-table__body td {
  padding: 0;
  height: 3.9vh;
  line-height: 3.9vh;
  color: #666666;
  font-size: 0.88rem;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #005E3A;
  color: #FFFFFF;
}
</style>
